/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Learn_Attemptcountone2Inputs */

const zh_learn_attemptcountone2 = /** @type {(inputs: Learn_Attemptcountone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次作答`)
};

const en_learn_attemptcountone2 = /** @type {(inputs: Learn_Attemptcountone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} attempt`)
};

const es_learn_attemptcountone2 = /** @type {(inputs: Learn_Attemptcountone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} intento`)
};

/**
* | output |
* | --- |
* | "{count} attempt" |
*
* @param {Learn_Attemptcountone2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_attemptcountone2 = /** @type {((inputs: Learn_Attemptcountone2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Attemptcountone2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_attemptcountone2(inputs)
	if (locale === "en") return en_learn_attemptcountone2(inputs)
	return es_learn_attemptcountone2(inputs)
});
export { learn_attemptcountone2 as "learn_attemptCountOne" }